import React from 'react';

const LoadingCreateComponent = () => {
    return (
        <div className="h-14 flex justify-end items-end">
            <div className="loader-create"></div>
        </div>
    );
};

export default LoadingCreateComponent;